import type ServiceApi from "../../api";
import {RevaApi} from "../api-constants";
import {PersistenceFetchApiInterface} from "./persistence-fetch";

/**
 * API interface for re-georeferencing the address of a valuation
 * (GET {@link RevaApi.PATH_VALUATIONS}/{id}/{@link RevaApi.PATH_VALUATION_ADDRESS_REFRESH}).
 *
 * reva-rest resolves the address again, stores the new coordinates and answers with the regular
 * {@link import("@reva/shared/valuation-data").ValuationData}, so GET execution and error handling
 * (incl. the R200/R220 "not found" mappings) are inherited from {@link PersistenceFetchApiInterface}.
 */
export class PersistenceGeorefRefreshApiInterface extends PersistenceFetchApiInterface {
    // biome-ignore lint/complexity/noUselessConstructor: drops the base forceUpdateExternalData parameter, which this endpoint has no query parameter for
    constructor(revaId: string) {
        super(revaId);
    }

    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([RevaApi.PATH_VALUATIONS, this.id, RevaApi.PATH_VALUATION_ADDRESS_REFRESH]);
    }
}
